import asset from '@/api/asset';

import { FETCH_SPLASH_RAND, FETCH_AVATAR_RAND } from './types';

export default {
    [FETCH_SPLASH_RAND]({ commit }) {
        return asset
            .getRandomSplash()
            .then(resp => commit(FETCH_SPLASH_RAND, resp));
    },
    [FETCH_AVATAR_RAND]({ commit }) {
        return asset
            .getRandomAvatar()
            .then(resp => commit(FETCH_SPLASH_RAND, resp));
    },
};



// WEBPACK FOOTER //
// ./src/store/asset/actions.js